module.exports = __webpack_public_path__ + "static/media/Bulletin.a6026ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductLandingPage/images/Bulletin.svg
// module id = 1017
// module chunks = 0